import { Cache } from "aws-amplify";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useRef } from "react";
import { validateEmail } from "../../utils/helper";
import { validationAPI } from "../../../api/fetch-api";

function ClientDetails(props) {
  const clientInfo = props.clientDetails;
  const emailRef = useRef();

  const SaveClientForm = () => {
    props.saveData({
      ...clientInfo,
      resultData: {
        ...clientInfo.resultData,
        emailAddress: emailRef.current.value,
      },
    });
  };

  const validateEmailViaAPI = async (event, isForm) => {
    let emailInputs = isForm ? event : event.target;
    let emailValue = isForm ? event.value : emailInputs.value;
    // Cache.setItem("travelReturnSubmit", null);
    // Cache.setItem("travelReturnSubmitAgent", null);
    // emailInputs.setCustomValidity(
    //   "Email Address matches with our agent records. Please provide a new email address."
    // ); // Set the custom error message
    // emailInputs.reportValidity();

    await validationAPI.getEmailValidation(emailValue).then((data) => {
      if (data.statusCode == "ISAGENT") {
        emailInputs.setCustomValidity(
          "Email Address matches with our agent records. Please provide a new email address."
        ); // Set the custom error message
        emailInputs.reportValidity();

        Cache.setItem("travelReturnSubmit", true);
        Cache.setItem("travelReturnSubmitAgent", true);
        Cache.setItem("travelOnBlur", true);
        return;
      } else if (
        data.statusCode == "UNDELIVERABLE" ||
        data.statusCode == "INVALID"
      ) {
        emailInputs.setCustomValidity(
          "Invalid email address format. Please provide a valid email address."
        ); // Set the custom error message
        emailInputs.reportValidity();
        Cache.setItem("travelReturnSubmit", true);
        Cache.setItem("travelReturnSubmitAgent", false);

        return;
      }

      emailInputs.setCustomValidity("");
      Cache.setItem("travelReturnSubmit", false);
      Cache.setItem("travelReturnSubmitAgent", false);
      return;
     });
  };

  useEffect(() => {
    if (props.handleNextState !== undefined) {
      props.handleNextState(() => SaveClientForm());
    }
  }, []);

  return (
    <>
      <div>
        <div className="text-left mb-24">
          <div className="mb-5">
            <h3 className="text-lg font-bold title-font">Client Details</h3>
          </div>
          <div className="mb-3">
            <label className="inline-block text-gray-500 text-sm font-bold">
              Full Name
            </label>
            <div className="block relative w-full">
              {clientInfo.resultData != null && (
                <input
                  type="text"
                  defaultValue={
                    clientInfo.resultData.firstName +
                    " " +
                    clientInfo.resultData.middleName +
                    " " +
                    clientInfo.resultData.lastName
                  }
                  className="input-border-none focus:outline-none focus:shadow-outline"
                  disabled={true}
                />
              )}
            </div>
          </div>
          <div className="mb-3">
            <label className="inline-block text-gray-500 text-sm font-bold">
              Birthday
            </label>
            <div className="block relative w-full">
              {clientInfo.resultData != null && (
                <input
                  type="text"
                  defaultValue={String(
                    dayjs(new Date(clientInfo.resultData.birthday)).format(
                      "MM/DD/YYYY"
                    )
                  )}
                  className="input-border-none focus:outline-none focus:shadow-outline"
                  disabled={true}
                />
              )}
            </div>
          </div>
          <div className="mb-3">
            <label className="inline-block text-gray-500 text-sm font-bold">
              Contact Number
            </label>
            <div className="block relative w-full">
              {clientInfo.resultData != null && (
                <input
                  type="text"
                  defaultValue={clientInfo.resultData.mobileNumber}
                  className="input-border-none focus:outline-none focus:shadow-outline"
                  disabled={true}
                />
              )}
            </div>
          </div>
          <div className="mb-3">
            <label className="inline-block text-gray-500 text-sm font-bold">
              Email Address
            </label>
            <div className="block relative w-full">
              <input
                type="email"
                name="emailAddress"
                ref={emailRef}
                defaultValue={clientInfo.resultData.emailAddress}
                placeholder="e.g. juancruz@gmail.com"
                className="input-border-none focus:outline-none focus:shadow-outline"
                required
                onBlur={(e) => {
                  validateEmail(e, false);
                  validateEmailViaAPI(e, false);
                }}
              />
            </div>
          </div>
          <div className="flex mt-5">
            <div>
              <input type="checkbox" required />
            </div>
            <div className="px-4">
              <p className="text-sm">
                Please verify that your email address is correct, as your policy
                schedule will be sent here.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ClientDetails;
